import { render, staticRenderFns } from "./ResponsiveVideoLoop.vue?vue&type=template&id=79a52eaf&"
import script from "./ResponsiveVideoLoop.vue?vue&type=script&lang=js&"
export * from "./ResponsiveVideoLoop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports